document.addEventListener('DOMContentLoaded', () => {
  const announcementCountDown = document.querySelector('.announcement-bar__countdown-banner');
  const announcementCountDownClose = document.querySelector('.countdown-banner__close');
  const announcementTopWrapper = document.querySelector('.announcement-bar__top-wrapper');
  const announcementTopWrapperClose = document.querySelector('.announcement-bar__top-wrapper--close');
  const checkAnnouncementCountDown = localStorage.getItem('countDownHide');
  const checkAnnouncementTopWrapper = localStorage.getItem('topAnnouncmentBarHide');

  if (checkAnnouncementCountDown) {
    if (announcementCountDown) {
      announcementCountDown.classList.add('hidden');
    }
  }

  if (checkAnnouncementTopWrapper) {
    if (announcementTopWrapper) {
      announcementTopWrapper.classList.add('hidden');
    }
  }
  if (announcementCountDownClose) {
    announcementCountDownClose.addEventListener('click', () => {
      announcementCountDown.classList.add('hidden');
      localStorage.setItem('countDownHide', 'true');
    });
  }

  if (announcementTopWrapperClose) {
    announcementTopWrapperClose.addEventListener('click', () => {
      announcementTopWrapper.classList.add('hidden');
      localStorage.setItem('topAnnouncmentBarHide', 'true');
    });
  }
});
